export default __webpack_public_path__ + "static/media/pen.1979d8ac.svg";